import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useCotizacionMasivaStore } from '../stores/cotizacion_masiva_store.js';

export function useMasivaProcesar() {
  const store = useCotizacionMasivaStore();

  const procesar = async () => {
    try {
      await store.procesarLote();
      if (store.resultadoLote) {
        useMessageSuccess().open(
          `Lote Nº ${store.resultadoLote.lote.numeroLote} procesado. Revisá el resultado.`,
        );
      }
    } catch (error) {
      useMessageError().open(error?.response?.data?.message || 'No se pudo procesar el lote.');
    }
  };

  return { procesar };
}
